import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

export default function Science({ theme, ...props }) {
  return (
    <svg
      aria-labelledby={props.ariaTags.labelledBy}
      aria-hidden={props.ariaTags.hidden}
      className={cx(theme.container, theme[props.svg], props.className)}
      shapeRendering="geometricPrecision"
      tabIndex={props.tabIndex}
      vectorEffect="non-scaling-stroke"
      viewBox="-5.5 -2.5 40 40"
      xmlns="http://www.w3.org/2000/svg"
    >
      {props.title ? (
        <title id={props.ariaTags.labelledBy} lang="en">
          {props.title}
        </title>
      ) : null}
      <g
        className={theme.stroke}
        fill="none"
        fillRule="evenodd"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M27.4099512 28.517842l-8.9903414-15.60636c-.3661464-.63492-.5584391-1.35498-.5584391-2.0889v-9.78054h-6.8560244v9.65052c0 .8184-.21534142 1.62228-.6236341 2.33112l-8.92514635 15.49416c-1.29204878 2.24268.32268293 5.04636 2.90612195 5.04636h20.1406829c2.5840976 0 4.1988293-2.80368 2.9067805-5.04636zM7.8885561 1.06468h13.104878M5.20073902 22.155706H23.3882024" />
      </g>
    </svg>
  )
}

Science.propTypes = {
  ariaTags: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  svg: PropTypes.string.isRequired,
  theme: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  className: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
}
